module.exports = __webpack_public_path__ + "static/media/timelapse_16.5ece313c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_16.jpg
// module id = 974
// module chunks = 0